    <template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:new="newHandler"
      v-on:delete="isConfirm = !isConfirm"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import MainForm from "../../../components/payroll/arrearsexercise/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": MainForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      loading: true,
      formData: [],
      pageTitle: this.$t('arrearsexercise.editarrearsexercise'),
      pageTitleValue: "",
      errMsg: "",
      isErr: false,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      if (this.formData.allowinput == true) {
        this.formData.allowinput = 1;
      } else {
        this.formData.allowinput = 0;
      }

      if (this.formData.ssrel == true) {
        this.formData.ssrel = 1;
      } else {
        this.formData.ssrel = 0;
      }

      this.$store.dispatch('put', {url: "/arrearsexercise/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "arrearsexerciselist" , params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/arrearsexercise/" +
            this.id})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "arrearsexerciselist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    newHandler() {
      this.$router.push({ name: "arrearsexercisenew" });
    },

    loadArrearsExercise() {
      const vm = this;

      this.$store.dispatch('get', {url: "/arrearsexercise/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          if (res.data.rec[0].inceffdate) {
            vm.formData.inceffdate = moment(res.data.rec[0].inceffdate).format(
              "YYYY-MM-DD"
            );
          }
          if (res.data.rec[0].actinceffdate) {
            vm.formData.actinceffdate = moment(res.data.rec[0].actinceffdate).format(
              "YYYY-MM-DD"
            );
          }
          if (res.data.rec[0].servicedate) {
            vm.formData.servicedate = moment(res.data.rec[0].servicedate).format(
              "YYYY-MM-DD"
            );
          }

          if (vm.formData.posted == "1") {
            vm.formData.posted = true;
          } else {
            vm.formData.posted = false;
          }

          if (vm.formData.exercisepo) {
            vm.formData.exercisepo.forEach((item) => {
              item.oripostartdate = moment(item.oripostartdate).format(
                "YYYY-MM-DD"
              );
              item.oripoenddate = moment(item.oripoenddate).format(
                "YYYY-MM-DD"
              );
            });
          }
          
          if (!vm.formData.exercisectrl) {
            vm.formData.exercisectrl = {
              dedtallw: false,
              dedtot: false,
              dedtbon: false,
              dedtbasic: false,
              dedtdedt: false,
              paydedt: false,
            };
          } else {
            if (vm.formData.exercisectrl.dedtallw == "1") {
              vm.formData.exercisectrl.dedtallw = true;
            } else {
              vm.formData.exercisectrl.dedtallw = false;
            }
            if (vm.formData.exercisectrl.dedtot == "1") {
              vm.formData.exercisectrl.dedtot = true;
            } else {
              vm.formData.exercisectrl.dedtot = false;
            }
            if (vm.formData.exercisectrl.dedtbon == "1") {
              vm.formData.exercisectrl.dedtbon = true;
            } else {
              vm.formData.exercisectrl.dedtbon = false;
            }
            if (vm.formData.exercisectrl.dedtbasic == "1") {
              vm.formData.exercisectrl.dedtbasic = true;
            } else {
              vm.formData.exercisectrl.dedtbasic = false;
            }
            if (vm.formData.exercisectrl.dedtdedt == "1") {
              vm.formData.exercisectrl.dedtdedt = true;
            } else {
              vm.formData.exercisectrl.dedtdedt = false;
            }
            if (vm.formData.exercisectrl.paydedt == "1") {
              vm.formData.exercisectrl.paydedt = true;
            } else {
              vm.formData.exercisectrl.paydedt = false;
            }
          }

          vm.pageTitleValue = ' ' + vm.formData.bpexercisedesc;
          vm.formData.userid = this.$store.getters.userId;

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  mounted() {
    this.loadArrearsExercise();
    
  },
};
</script>

<style scoped>
</style>